import React,{ useState } from 'react'
import { Tabs } from 'antd';
import { TabItem,DetailContainer, TabImg, TabHead, TabTitle, TabPaneItem } from '../../../StyledComponents/CreateKeyAccountManager'
import ProfileSection from '../UserManagement/ProfileSection';
import ProfileDetails from './ProfileDetails';
import Organizationcreate from '../UserManagement/Organizationcreate';


import DocumentDetails from './DocumentDetails';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setOrganizationCreated } from '../../../store/Organization/organizationSlice';


const { TabPane } = Tabs;
function KYCView(props) {
  console.log({props});
  const location = useLocation();
  const dispatch = useDispatch();
  const [isLoad, setIsLoad] = useState(true);
  // const isOrganizationCreated = useSelector(
  //   (state) => state.organization.isOrganizationCreated
  // );
  // console.log("hiiiijdcnbfjncjk",isOrganizationCreated);
  const isOrganizationCreated = useSelector((state) => state?.organization?.isOrganizationCreated);
  // The "organization created" flag is a global redux value shared across the
  // KYC and User-Management views. It is set to true only when the user clicks
  // "Create Organization" (to swap in the create form). Reset it on mount so a
  // freshly opened View always starts on the Details tab instead of getting
  // stuck on the create form left over from a previous, un-submitted session.
  useEffect(()=> {
    dispatch(setOrganizationCreated(false))
  },[])
  useEffect(()=> {
    if(location.pathname === '/kyc-verification'){
      if(isLoad === false){
        props.setPageType("table")
      }else {
        setIsLoad(false)
      }
    }
  },[location])


    const [currentTab, setCurrentTab] = useState(props.tab? props.tab : "1");
    const callback = (key)=> {
        setCurrentTab(key)
    }
    const items = [
        {
          key: '1',
          tab: (
            <TabHead>
                {currentTab === "1" ? <TabImg src={require('../../../assets/admin/images/user-squaretab_active.png')} />:<TabImg src={require('../../../assets/admin/images/user-squaretab.png')} /> }
                <TabTitle active={currentTab === "1"}>
                    Details
                </TabTitle>
            </ TabHead>
          ),
          content: <ProfileDetails instance={props.instance} />,
        },
        {
            key: '2',
            tab: (
              <TabHead>
                  {currentTab === "2" ? <TabImg src={require('../../../assets/admin/images/finger-scantab_active.png')} />:<TabImg src={require('../../../assets/admin/images/finger-scantab.png')} /> }
                  <TabTitle active={currentTab === "2"}>
                      Documents
                  </TabTitle>
              </ TabHead>
            ),
            content: <DocumentDetails instance={props.instance} setPageType={props.setPageType} />,
          },
        
        
      ];
        const items1 = [
              {
                key: '1',
                tab: (
                  <TabHead>
                      {currentTab === "1" ? <TabImg src={require('../../../assets/admin/images/user-squaretab_active.png')} />:<TabImg src={require('../../../assets/admin/images/user-squaretab.png')} /> }
                      <TabTitle active={currentTab === "1"}>
                        Profile
                      </TabTitle>
                  </ TabHead>
                ),
                content: <Organizationcreate instance={{ ...props.instance, type:"kyc"  }}  />,
              },
            
            ];
      // const items1 = [
      //   {
      //     key: '1',
      //     tab: (
      //       <TabHead>
      //           {currentTab === "1" ? <TabImg src={require('../../../assets/admin/images/user-squaretab_active.png')} />:<TabImg src={require('../../../assets/admin/images/user-squaretab.png')} /> }
      //           <TabTitle active={currentTab === "1"}>
      //             Profile
      //           </TabTitle>
      //       </ TabHead>
      //     ),
      //     content: <Organizaionadd instance={props} />,
      //   },
      //   {
      //       key: '2',
      //       tab: (
      //         <TabHead>
      //             {currentTab === "2" ? <TabImg src={require('../../../assets/admin/images/finger-scantab_active.png')} />:<TabImg src={require('../../../assets/admin/images/finger-scantab.png')} /> }
      //             <TabTitle active={currentTab === "2"}>
      //               Quotes Accepted
      //             </TabTitle>
      //         </ TabHead>
      //       ),
      //       content:<OrgquotesAccepted/>,
      //     },
        
        
      // ];
  return (
    <DetailContainer className='user-management'>
       <TabItem
        tabPosition="left"
        defaultActiveKey={props.tab? props.tab : "1"}
        onChange={callback}
        items= {(isOrganizationCreated? items1 : items).map((i,idx) => {
            const id = String(idx + 1);
            return {
              label: i.tab,
              key: i.key,
              children: i.content,
            };
          })}
      />
    </DetailContainer>
  )
}

export default KYCView
